import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationStart, PRIMARY_OUTLET, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ApplicationloaderComponent } from './shared/components/layout/applicationloader/applicationloader.component';
import { AuthService } from './_services/auth/auth.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { TranslationService } from './shared/services/translation.service';
import { LoadingService } from './_services/LoadingService/loading.service';
import { filter, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    LoaderComponent,
    ApplicationloaderComponent,
    HttpClientModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  companyCode!: string;
  header: any;
  qrCodeData: string
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private titleService: Title,
    private http: HttpClient,
    private translateService: TranslationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
  ) {
    this.getCompany();
    this.setupNavigationLoader();
    this.route.paramMap.subscribe(params => {
      //this.companyCode = params.get('companyCode') || '';
      //localStorage.setItem('companyCode', this.companyCode);
      this.updateTitle(); // Update title on route change
    });
    const companyCode = localStorage.getItem('companyCode') || this.companyCode;
    this.header = {
      'CompanyCode': companyCode // Use companyCode as a header
    };
  }
  getCompany() {
    const companyProfile = localStorage.getItem('companyProfile');

    if (companyProfile) {
      // Parse it to object if available
      const companyData = JSON.parse(companyProfile);
      this.qrCodeData = JSON.stringify(companyData);

      // Set the document title using companyName
      if (companyData.companyName) {
        this.titleService.setTitle(companyData.companyName);
      }
    }
  }

  setupNavigationLoader() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Show loader when navigating to shift-time routes
        if (event.url.includes('/scheduling/shift-time')) {
          this.loadingService.showLoader();
        }
      } else if (event instanceof NavigationEnd) {
        // Hide loader after navigation completes
        setTimeout(() => {
          this.loadingService.hideLoader();
        }, 800); // Small delay to ensure smooth transition
      }
    });
  }

  updateTitle() {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe((route:any) => {
        let snapshot = this.router.routerState.snapshot;
        let currentRouteTitle = route.snapshot.data['title'];
        let parent = route.parent.snapshot.data['breadcrumb'];
        let child = route.snapshot.data['breadcrumb'];
        const companyProfile = localStorage.getItem('companyProfile');
        if (companyProfile) {
          const companyData = JSON.parse(companyProfile);
          const companyName = companyData.companyName || '';
          if (!currentRouteTitle) {
            const translatedTitle = this.translateService.getTranslatedValue(currentRouteTitle);
            const newTitle = `${translatedTitle} - ${companyName}`;
            this.titleService.setTitle(newTitle);
          }
          else {
            this.titleService.setTitle(companyName);
          }
        }
        
      });


  }
}